export default "__VITE_ASSET__koU18EvS__"